import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useToast } from '@/hooks/use-toast';
import { Loader2 } from 'lucide-react';

export default function FixCredentials() {
  const [loading, setLoading] = useState(false);
  const { toast } = useToast();

  const fixCredentials = async () => {
    setLoading(true);
    try {
      const { data, error } = await supabase.functions.invoke('fix-credentials');

      if (error) throw error;

      toast({
        title: 'Credentials corrigés',
        description: 'Les credentials Amazon SP-API ont été corrigés avec succès.',
      });

      console.log('Fix result:', data);
    } catch (error: any) {
      toast({
        title: 'Erreur',
        description: error.message,
        variant: 'destructive',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mx-auto p-8">
      <Card>
        <CardHeader>
          <CardTitle>Corriger les credentials Amazon SP-API</CardTitle>
          <CardDescription>
            Cette page permet de corriger les credentials Amazon SP-API pour le client Karaskin Paris.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Button onClick={fixCredentials} disabled={loading}>
            {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
            Corriger les credentials
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
